export default __webpack_public_path__ + "static/media/dreadshadow.c74b8174.png";